export const DATE_COLUMN_WIDTH = 110;
export const DATA_COLUMN_WIDTH = 345;
export const MIN_DATA_COLUMN_WIDTH = 60;
export const MAX_DATA_COLUMN_WIDTH = 520;
export const RESIZE_KEYBOARD_STEP = 16;
export const COLUMN_WIDTHS_STORAGE_KEY = 'spot-history-table-column-widths';
export const TABLE_HEADER_HEIGHT_PX = 40;
